<script lang="ts">
  import { mapOpt } from '#lib/overview/utils/object.js';

  interface Props {
    selected?: boolean | null;
    size?: number | undefined;
    onSelect?: (selected: boolean) => void;
  }

  let { selected = false, size, onSelect }: Props = $props();
  let sizePx = $derived(mapOpt(size, (s) => `${s}px`));

  let checked = $derived(selected === true);
  let indeterminate = $derived(selected === null);
</script>

<input
  class="checkbox checkbox-primary checkbox-sm not-checked:border-base-content/50 rounded-sm"
  type="checkbox"
  bind:checked={() => checked, () => (checked = selected === true)}
  bind:indeterminate={() => indeterminate, () => (indeterminate = selected === null)}
  style:width={sizePx}
  style:height={sizePx}
  onclick={() => onSelect?.(!selected)}
/>
